<div class="defectboxlayout">
    <div class="boxlayout">
        <div class="boxtitle color-A"> A </div>
        <div class="boxinfo"> {{dpiDefectACount}} </div>
    </div>
    <div class="boxlayout">
        <div class="boxtitle color-B"> B </div>
        <div class="boxinfo"> {{dpiDefectBCount}} </div>
    </div>
    <div class="boxlayout">
        <div class="boxtitle color-C"> C </div>
        <div class="boxinfo"> {{dpiDefectCCount}} </div>
    </div>
    <div class="boxlayout">
        <div class="boxtitle color-D"> D </div>
        <div class="boxinfo"> {{dpiDefectDCount}} </div>
    </div>
</div>